import { type PropsWithChildren } from 'react';

import { CurrentMonthProvider } from '../calendar';
import { CurrentUserProvider } from '../current-user';
import { PreferencesProvider } from '../preferences';
import { SettingsProvider } from '../settings/SettingsProvider';
import { ThemeProvider } from '../theme';
import { PendingProvider } from '../worklog/PendingProvider';
import { ErrorBoundary } from './ErrorBoundary';

export const Providers: React.FC<PropsWithChildren> = ({ children }) => (
    <ErrorBoundary
        log={(error, info) => {
            // eslint-disable-next-line no-console
            console.error('Unhandled error in render tree', error, info);
        }}
        fallback={({ error }) => (
            <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
                <h1>Something went wrong</h1>
                <pre>{error.message}</pre>
            </div>
        )}
    >
        <PreferencesProvider>
            <ThemeProvider>
                <SettingsProvider>
                    <CurrentUserProvider>
                        <PendingProvider>
                            <CurrentMonthProvider>{children}</CurrentMonthProvider>
                        </PendingProvider>
                    </CurrentUserProvider>
                </SettingsProvider>
            </ThemeProvider>
        </PreferencesProvider>
    </ErrorBoundary>
);
